import { render, staticRenderFns } from "./VideoArea.vue?vue&type=template&id=5a2f740d&"
import script from "./VideoArea.vue?vue&type=script&lang=js&"
export * from "./VideoArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports